import React, { useState } from "react";
import {
  Popover,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Box,
  IconButton,
  InputAdornment,
  OutlinedInput,
  FormControl,
  InputLabel,
} from "@mui/material";

import styles from "./index.module.scss";
import "./mui-styles.scss";

export default function CustomSearchDropdown({
  label,
  options = [],
  value = [],
  onChange,
  width = 300,
  extraClass,
  fullWidth,
  error,
  showEndIcon,
  endIcon,
  disabled
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");

  const open = Boolean(anchorEl);

  const customClass = `${styles.inputField} ${extraClass} ${
    fullWidth ? styles.fullWidth : ""
  } ${error ? styles.error : ""}`;

  const handleToggle = (item) => {
    const updated = value.includes(item.value)
      ? value.filter((v) => v !== item.value)
      : [...value, item.value];

    onChange(updated);
  };

  const filteredOptions = options.filter((option) => {
    if (typeof option === "string") {
      return option.toLowerCase().includes(search.toLowerCase());
    }
    if (option && option.label) {
      return option.label.toLowerCase().includes(search.toLowerCase());
    }
    return false;
  });

  const displayValue = options
  .filter((opt) => value.includes(opt.value))
  .map((opt) => opt.label)
  .join(", ");

  return (
    <>
      {/* Trigger Input (Design Updated) */}
      <FormControl fullWidth={fullWidth} error={error}>
        <InputLabel shrink>{label}</InputLabel>

        <OutlinedInput
          readOnly
          value={displayValue}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          className={customClass}
          disabled={disabled}
          endAdornment={
            showEndIcon && (
              <InputAdornment position="end">
                <IconButton edge="end" disabled={disabled}>
                  {endIcon}
                </IconButton>
              </InputAdornment>
            )
          }
        />
        
      </FormControl>

      {/* Popup */}
      <Popover
        disabled
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            width: anchorEl ? anchorEl.clientWidth : undefined,
          },
        }}
      >
        <Box p={1}>
          <OutlinedInput
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          
          />
        </Box>

        <List sx={{ maxHeight: 220, overflowY: "auto" }}>
          {filteredOptions.map((option) => (
            <ListItem
              key={option.value}
              component="div"       // no more 'button' prop
              onClick={() => !disabled && handleToggle(option)}
              style={{ cursor: disabled ? "not-allowed" : "pointer" }} // optional
            >
              <Checkbox
              className={styles.customCheckbox}
                checked={value.includes(option.value)}
                disabled={disabled}  // prevent checking
                
              />
              <ListItemText primary={option.label} />
            </ListItem>
          ))}
        </List>

      </Popover>
    </>
  );
}
